import React from 'react';
import clsx from 'clsx';

import styles from './InfoWindow.module.scss';
import Pic from './Pic';
import Info from './Info';
import Icon from './Icon';
import TimeTable from './TimeTable';
import Tail from './Tail';
import {
	CURRENT_CRI_LIST,
	FILIALI_PROJECT,
	PROJECT_ASG,
	PROJECT_BSG,
	PROJECT_CAR,
	PROJECT_CGR,
	PROJECT_CSV,
	PROJECT_EUG,
	PROJECT_HGG,
	PROJECT_ING,
	PROJECT_LTG,
	PROJECT_NSG,
	PROJECT_STS,
	PROJECT_SOS,
	PROJECT_UGG,
	TC_EVENT_NAMES
} from '../utils/Constants';
import { useDeviceDetection } from '../utils/DeviceDetection';
import FloatingToggleButton from './FloatingToggleButton';
import { useTCLog } from '../utils/TCEvent';
import { hasBrandLabel } from '../api/brandUtil';

export default function InfoWindow({
	result,
	onClose,
	onCalcRouteClick,
	onStreetViewClick,
	onDetailClick
}) {
	const isMobile = useDeviceDetection();
	const [showTimeTable, setShowTimeTable] = React.useState(false);
	const [TCLog] = useTCLog();

	const isBrandLabel = hasBrandLabel(result);

	return result ? (
		<div className={styles.root}>
			<div className={styles.infoWindowContainer}>
				<div className={styles.infoWindow}>
					{!(
						CURRENT_CRI_LIST.includes(result.project) ||
						result.subAgencyId
					) ? (
						<div className={styles.tabs}>
							<div
								className={clsx(
									styles.tab,
									!showTimeTable ? styles.active : null
								)}
								onClick={() => setShowTimeTable(false)}
							>
								Info
							</div>
							{result.timeTable ? (
								<div
									className={clsx(
										styles.tab,
										showTimeTable ? styles.active : null
									)}
									onClick={() => setShowTimeTable(true)}
								>
									Orari
								</div>
							) : null}
						</div>
					) : (
						<div className={styles.paddingTop}></div>
					)}

					<FloatingToggleButton
						className={isMobile ? styles.close : null}
						enabled={true}
						icon={
							<Icon
								icon={
									isMobile
										? 'icon/close_grey.png'
										: 'icon/close_white.png'
								}
								size="small"
							/>
						}
						onClick={() => onClose(null)}
						right={isMobile ? '10px' : '-40px'}
						top={isMobile ? '10px' : '0'}
					/>

					<div
						id={'infoContainer_' + result.id}
						className={showTimeTable ? styles.hide : null}
					>
						<div
							className={clsx(
								styles.infoContainer,
								isBrandLabel ? styles.infoContainerColumn : null
							)}
						>
							<Pic
								brand={result.brand}
								distance={result.distance}
							/>
							<Info
								name={result.name}
								address={result.address}
								flex={false}
								calcRoute={true}
								streetView={true}
								resultId={result.id}
								isRankedAgency={result.isRankedAgency}
								variant={isBrandLabel ? 'block' : null}
								onCalcRouteClick={() => {
									onCalcRouteClick(result);
									TCLog(TC_EVENT_NAMES.CALC_ROUTE);
								}}
								onStreetViewClick={() => {
									onStreetViewClick(result);
									TCLog(TC_EVENT_NAMES.STREET_VIEW);
								}}
							/>
						</div>
						<div>
							<Info
								variant="block"
								phone={result.phone}
								fax={result.fax}
								email={result.email}
								site={result.site}
								isRankedAgency={result.isRankedAgency}
								facebook={result.facebook}
							/>
							{result.additionalInfo}
						</div>
					</div>
					{result.timeTable ? (
						<div
							className={showTimeTable ? null : styles.hide}
							id={'timeTableContainer_' + result.id}
						>
							<TimeTable data={result.timeTable} />
						</div>
					) : null}

					<div
						className={
							result.project == PROJECT_CAR ? styles.footer : null
						}
						onClick={
							result.detail
								? () => onDetailClick(result)
								: result.project == PROJECT_CSV ||
								  result.project == PROJECT_CGR ||
								  result.project == PROJECT_BSG ||
								  result.project == PROJECT_LTG ||
								  result.project == PROJECT_EUG ||
								  result.project == PROJECT_HGG ||
								  result.project == PROJECT_UGG ||
								  result.project == PROJECT_ASG ||
								  result.project == PROJECT_ING ||
								  result.project == PROJECT_NSG ||
								  result.project == PROJECT_STS ||
								  result.project == FILIALI_PROJECT
								? () => {
										onCalcRouteClick(result);
										TCLog(TC_EVENT_NAMES.CALC_ROUTE);
								  }
								: null
						}
					>
						{result.infoWindowFooter}
					</div>

					{!isMobile ? <Tail /> : null}
				</div>
			</div>
		</div>
	) : null;
}
